/** `.zwdoc` conversion commands (#259): desktop and web sessions alike. */

import { invoke } from "../invoke";
import type { ConversionPlan, ProjectFile } from "../zwdoc/convertProject";

export type LegacyDocuments = {
  documents: ProjectFile[];
  existing: string[];
  zwconfig: string | null;
  zwgraph: string | null;
};

export function listLegacyDocuments(
  rootPath: string,
): Promise<LegacyDocuments> {
  return invoke<LegacyDocuments>("list_legacy_documents", { rootPath });
}

/** Writes the plan and commits "Convert documents to .zwdoc". */
export async function convertProjectDocuments(
  rootPath: string,
  plan: ConversionPlan,
): Promise<void> {
  await invoke("convert_project_documents", {
    rootPath,
    plan: { writes: plan.writes, removes: plan.removes },
  });
}
